<template>
  <section :class="['section', 'child-view', 'section--expertise', 'section--expertise-child', 'section--expertise-interact']">
    <div class="wrapper" :class="{ 'with-modal': isModalVisible}">
      <div class="content">
        <div class="heading">
          <div class="back-btn">
            <router-link
              :to="`/expertise`">
            </router-link>
            <span>back</span>
          </div>
        </div>
        <div class="expertise-holder">
          <ul class="parts-number">
            <li class="number-3">
              <span class="number">/3</span>
              <span class="text">Artificial Intelligence</span>
              <ul class="list-tools">
                <li>
                  <img src="../assets/images/programs_icons/claude.svg" alt="blender">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/stitch.svg" alt="adobe animate">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/lovable.svg" alt="cinema4d">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/aistudio.svg" alt="autodesk maya">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/antigravity.svg" alt="unity">
                </li>
              </ul>
            </li>
          </ul>
          <div class="expertise-container">
            <span class="circle-title">AI</span>
            <div class="circle-holder">
              <ul class="circle-block">
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('lovable')">
                    <span class="text">Lovable</span>
                  </div>
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('stitch')">
                    <span class="text">Google Stitch</span>
                  </div>
                </li>
                <li class="circle-button size-3">
                  <div class="text-holder"
                    @click="openModal('claude')">
                    <span class="text">Anthropic Claude</span>
                  </div>
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('antigravity')">
                    <span class="text">Google Antigravity</span>
                  </div>
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('aistudio')">
                    <span class="text">Google AI Studio</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div><!--end content-->
    </div>
    <window-modal v-show="isModalVisible" v-model="modalData[activeItem]" @close="closeModal"></window-modal>
  </section>
</template>

<script>
import Footer from '@/components/UI/Footer';
import { mapActions } from 'vuex';
import WindowModal from '@/components/modals/WindowModal.vue';

export default {
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  data() {
    return {
      isModalVisible: false,
      activeItem: 'lovable',
      modalData: {
        lovable: {
          title: 'Lovable',
          content: 'Great for quickly turning UI ideas and design concepts into functional web prototypes. It helps designers validate interactions and product flows without heavy coding.',
          linkUrl: 'https://lovable.dev',
          sizeClass: 'size-2',
          positionClass: 'down-position',
        },
        stitch: {
          title: 'Google Stitch',
          content: 'Excellent for generating UI concepts and exploring different design directions from simple prompts. It’s especially useful for quickly moving from an idea to polished screens and layouts.',
          linkUrl: 'https://stitch.withgoogle.com',
          sizeClass: 'size-2',
        },
        claude: {
          title: 'Anthropic Claude',
          content: 'A strong AI assistant for UX thinking, design analysis, documentation, and working with complex product requirements. It can help designers structure ideas, review UX decisions, and generate or refine interface code.',
          linkUrl: 'https://clude.ai',
          sizeClass: 'size-3',
        },
        antigravity: {
          title: 'Google Antigravity',
          content: 'Useful for exploring and prototyping product experiences with AI-driven development workflows. It helps bridge the gap between design concepts and working interfaces.',
          linkUrl: 'https://antigravity.google',
          sizeClass: 'size-2',
        },
        aistudio: {
          title: 'Google AI Studio',
          content: 'A powerful environment for experimenting with Gemini and building AI-powered product concepts. For designers, it’s useful for rapid prototyping, generating UI/code, and testing AI-driven interactions.',
          linkUrl: 'https://aistudio.google.com',
          sizeClass: 'size-2',
          positionClass: 'down-position',
        },
      },
    };
  },
  methods: {
    ...mapActions({ fetchExpertisePageContent: '/expertise/expertise:fetch' }),
    openModal(activeItemName) {
      this.activeItem = activeItemName;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    },
  },
  components: {
    Footer,
    WindowModal,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ExpertiseAi.vue